// this file is generated by update_shopify_store_data.py at 2026-01-26 20:23:25.182898
var courses = [];